import {Action, State, StateContext} from '@ngxs/store';
import {catchError, tap} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {ModalService} from '../../services/modal.service';
import {ImportModalActions} from '../import-modal/import-modal.actions';
import {NotificationService} from '../../services/notification.service';
import {TranslateService} from '@ngx-translate/core';
import {SearchListActions} from '../search-list/search-list.actions';
import {SearchListEnum} from '../../enums/search-list.enum';
import {EnelmedCertificateService} from '../../services/enelmed-certificate.service';
import {EnelmedCertificateActions} from './enelmed-certificate.actions';
import {
    EnelmedCertificateImportEnum,
    EnelmedCertificateImportTitleLabel,
} from '../../enums/enelmed-certificate-import.enum';

interface EnelmedCertificateStateModel {}

@State<EnelmedCertificateStateModel>({
    name: EnelmedCertificateState.STATE_NAME,
    defaults: {},
})
@Injectable()
export class EnelmedCertificateState {
    static readonly STATE_NAME = 'enelmedCertificate';

    constructor(
        private enelmedCertificateService: EnelmedCertificateService,
        private modalService: ModalService,
        private notificationService: NotificationService,
        private translateService: TranslateService
    ) {}

    @Action(EnelmedCertificateActions.Clear)
    userClear(ctx: StateContext<EnelmedCertificateState>) {
        ctx.patchState({});
    }

    @Action(EnelmedCertificateActions.Import)
    import(ctx: StateContext<EnelmedCertificateState>, {operation}: EnelmedCertificateActions.Import) {
        return this.modalService.importFile({
            nzTitle: this.translateService.instant(EnelmedCertificateImportTitleLabel[operation]),
            nzData: {
                action: (payload) => new EnelmedCertificateActions.SendFile(payload, operation),
                extensions: ['xlsx'],
                labelsPrefix: 'enelmed_certificate',
            },
        });
    }

    @Action(EnelmedCertificateActions.SendFile)
    sendFile(ctx: StateContext<EnelmedCertificateState>, {file, operation}: EnelmedCertificateActions.SendFile) {
        return this.enelmedCertificateService.sendFile(file, operation).pipe(
            tap(() => {
                this.modalService.closeAll();
                if (operation === EnelmedCertificateImportEnum.IN) {
                    this.notificationService.success(
                        this.translateService.instant('ENELMED_CERTIFICATE.IMPORT_IN_SUCCESS')
                    );
                } else if (operation === EnelmedCertificateImportEnum.OUT) {
                    this.notificationService.success(
                        this.translateService.instant('ENELMED_CERTIFICATE.IMPORT_OUT_SUCCESS')
                    );
                }
                ctx.dispatch(new SearchListActions.GetListPage(SearchListEnum.ENELMED_CERTIFICATE));
            }),
            catchError(({error}) => {
                return ctx.dispatch(new ImportModalActions.UpdateFileErrors(error.entities));
            })
        );
    }
}
